<template>
  <Teleport to="body">
    <div class="modal modal-car-gallery show" style="display: block">
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content bg-transparent border-0">
          <div class="modal-body p-0">
            <button type="button" class="btn-close" aria-label="Zavřít" @click="close">
              <i class="icon icon--lg icon-dismiss d-none d-md-block"></i>
              <i class="icon icon-dismiss d-md-none"></i>
            </button>
            <button
              type="button"
              class="btn-scale"
              :class="{ active: zoomActive }"
              aria-label="Přiblížit"
              @click="toggleZoom"
            >
              <i class="icon icon--lg icon-zoom d-none d-md-block"></i>
              <i class="icon icon-zoom d-md-none"></i>
            </button>

            <Swiper
              class="swiper-modal"
              :modules="modules"
              :slides-per-view="1"
              :space-between="0"
              :centered-slides="true"
              :loop="photos.length > 1"
              :threshold="20"
              :virtual="true"
              :zoom="{ containerClass: 'swiper-zoom-container' }"
              :navigation="{
                prevEl: '.swiper-modal .swiper-button-prev',
                nextEl: '.swiper-modal .swiper-button-next',
              }"
              :keyboard="{ enabled: true }"
              @swiper="onSwiper"
              @slide-change="onSlideChange"
              @zoom-change="onZoomChange"
            >
              <SwiperSlide
                v-for="(photo, index) in photos"
                :key="index"
                :virtual-index="index"
              >
                <div class="swiper-zoom-container">
                  <img :src="photo.modal" :alt="photo.alt" loading="lazy" />
                </div>
              </SwiperSlide>
              <template #container-end>
                <div class="swiper-button-prev" role="button" aria-label="Zpět">
                  <i class="icon icon--xl icon-right-circle bg-white"></i>
                </div>
                <div class="swiper-button-next" role="button" aria-label="Dopředu">
                  <i class="icon icon--xl icon-right-circle bg-white"></i>
                </div>
              </template>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Keyboard, Zoom, Virtual } from 'swiper/modules'
import 'swiper/css/zoom'

const props = defineProps({
  photos: { type: Array, required: true },
  activeIndex: { type: Number, default: 0 },
})

const emit = defineEmits(['close', 'update:activeIndex'])

const modules = [Navigation, Keyboard, Zoom, Virtual]
const zoomActive = ref(false)
let swiperInstance = null

function onSwiper(swiper) {
  swiperInstance = swiper
  swiper.slideToLoop(props.activeIndex, 0, false)
}

function onSlideChange(swiper) {
  emit('update:activeIndex', swiper.realIndex)
}

function onZoomChange(swiper, scale) {
  zoomActive.value = scale !== 1
}

function toggleZoom() {
  if (swiperInstance) swiperInstance.zoom.toggle()
}

function close() {
  if (swiperInstance) swiperInstance.zoom.out()
  emit('close')
}

function handleKeydown(e) {
  if (e.key === 'Escape') close()
}

onMounted(() => {
  document.body.classList.add('modal-open')
  document.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  document.body.classList.remove('modal-open')
  document.removeEventListener('keydown', handleKeydown)
})
</script>
